import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { Breadcrumb } from "@/components/Breadcrumb";
import { FaqAccordion } from "@/components/FaqAccordion";
import { CTABlock } from "@/components/CTABlock";
import { FAQS } from "@/data/faq";
import { FAQS_EN } from "@/data/faq.en";
import { useLang } from "@/i18n/LangContext";

export default function FaqPage() {
  const { t, lang } = useLang();
  const faqs = lang === "en" ? FAQS_EN : FAQS;
  const f = t.faqPage;

  return (
    <>
      <Seo
        title={f.seo.title}
        description={f.seo.description}
        path="/faq"
        schemas={[
          breadcrumbSchema([
            { name: t.common.home, path: "/" },
            { name: f.breadcrumb, path: "/faq" },
          ]),
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((x) => ({
              "@type": "Question",
              name: x.q,
              acceptedAnswer: { "@type": "Answer", text: x.a.replace(/\[\[[^\]|]+\|([^\]]+)\]\]/g, "$1") },
            })),
          },
        ]}
      />

      <section className="px-5 md:px-10 pt-36 md:pt-44 pb-24 md:pb-32" data-testid="faq-page">
        <div className="mx-auto max-w-4xl">
          <Breadcrumb items={[{ label: t.common.home, to: "/" }, { label: f.breadcrumb }]} />
          <div>
            <SectionTag>{f.tag}</SectionTag>
            <Reveal delay={0.1}>
              <h1 className="mt-5 font-display text-4xl md:text-6xl font-extrabold tracking-tighter text-balance">
                {f.h1}
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-7 max-w-2xl text-base md:text-lg leading-relaxed text-plum/85">
                {f.intro}
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.25} className="mt-14">
            <FaqAccordion items={faqs} testidPrefix="faq-page" />
          </Reveal>
        </div>
      </section>

      <CTABlock
        title={f.ctaTitle}
        text={f.ctaText}
      />
    </>
  );
}
